/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'up': {
    width: 10,
    height: 5,
    viewBox: '0 0 10 5',
    data: '<path pid="0" d="M0 5l5-5 5 5H0z"/>'
  }
})
